import React from 'react'
import { Alert, AlertTitle, List, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import type { PairedRuuviTag } from '../../types'
import RuuviTagScannedListItemButton from './RuuviTagScannedListItemButton'

export interface RuuviTagScannerListProps {
  ruuviTags: PairedRuuviTag[]
  onSelect: (tag: PairedRuuviTag) => void
  onExitInstallation: () => void
  onTagUpdate?: (tag: PairedRuuviTag) => void
}

export default function RuuviTagScannerList({
  ruuviTags,
  onSelect,
  onExitInstallation,
  onTagUpdate
}: RuuviTagScannerListProps) {
  const { t } = useTranslation('installation')

  if (!ruuviTags?.length) return null

  return (
    <Stack direction="column" gap={2} sx={{ mt: 2 }}>
      <Alert color="success">
        <AlertTitle sx={{ m: 0 }}>
          {ruuviTags.length > 1
            ? t('foundRuuviTags', { count: ruuviTags.length })
            : t('foundRuuviTag')}
        </AlertTitle>
      </Alert>

      <List disablePadding>
        {ruuviTags.map((tag) => (
          <RuuviTagScannedListItemButton
            key={tag.id}
            tag={tag}
            onSelect={onSelect}
            onExitInstallation={onExitInstallation}
            onTagUpdate={onTagUpdate}
          />
        ))}
      </List>
    </Stack>
  )
}
